"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var LabelAfter = function (_a) {
    var className = _a.className, financeDetails = _a.financeDetails;
    var _b, _c;
    return (<core_1.Typography variant="subtitle2" className={className} component="span">
      <Translation_1.default id={'financeSummary.text.monthlyPaymentsDescription'} values={{
        frequency: (_b = financeDetails) === null || _b === void 0 ? void 0 : _b.frequency,
        duration: (_c = financeDetails) === null || _c === void 0 ? void 0 : _c.duration,
    }}/>
    </core_1.Typography>);
};
exports.default = LabelAfter;
